export default "/assets/images/mila-valentine-mobile.png?6ac7ca41c0279f2e87dee13aa94972ee";